import React from "react";

import { Text, StyleSheet, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  questionTitle: {
    color: "#3b598d",
    marginBottom: "2mm",
    fontSize: "4.5mm",
  },
  questionDescription: {
    color: "#4C566A",
    marginBottom: "6mm",
    fontSize: "3.5mm",
  },
});

type ReportQuestionTitleProps = {
  title: string;
  questionDescription: string;
  description: string;
  timeSpent?: number;
  index: number;
};

const ReportQuestionTitle: React.FC<ReportQuestionTitleProps> = ({
  title,
  questionDescription,
  description,
  timeSpent,
  index,
}) => (
  <View>
    <Text style={styles.questionTitle}>
      {index}. {title} {timeSpent && ` (${timeSpent}h)`}
    </Text>
    <Text style={styles.questionDescription}>{questionDescription}</Text>
    <Text style={styles.questionDescription}>{description}</Text>
  </View>
);

export default ReportQuestionTitle;
